module.exports = __webpack_public_path__ + "img/health10_7-9-2021.b65aaf66.jpg";